// Hard coded time for type of action, corresponding to different parts

let userlogo = {
  justos: ["justos.png", "https://www.justos.com"],
};

export default userlogo;
